
namespace GeniuzPOS.ReportMasterData {
    import fld = Report_1301Row.Fields;
    @Serenity.Decorators.registerClass()
    export class Report_1301Grid extends Serenity.EntityGrid<Report_1301Row, any> {
        protected getColumnsKey() { return Report_1301Columns.columnsKey; }
        protected getDialogType() { return Report_1301Dialog; }
        protected getIdProperty() { return Report_1301Row.idProperty; }
        protected getInsertPermission() { return Report_1301Row.insertPermission; }
        protected getLocalTextPrefix() { return Report_1301Row.localTextPrefix; }
        protected getService() { return Report_1301Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);

        }
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            // let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            // let columns = Object.keys(options.columnStyles)

            
            let descriptions: string[] = [];
            let shop = QRreport.QRywcSpecRow.getLookup().itemById["3"].ShopId;
            let startDate = QRreport.QRywcSpecRow.getLookup().itemById["3"].DateBegin;
            let endDate = QRreport.QRywcSpecRow.getLookup().itemById["3"].DateEnd;
            let qstartDate =Q.formatDate(startDate, "dd/MM/yyyy")
            let qendDate =Q.formatDate(endDate, "dd/MM/yyyy")
            var reportdata = ""
            if (shop != null) {
                reportdata = "ระหว่างวันที่ " +qstartDate +" - " +qendDate+ "   ระบุร้านค้า รหัส"+shop
                descriptions.push(reportdata)
            } else
            {
                shop = "ไม่ระบุ"
                reportdata = "ระหว่างวันที่ " +qstartDate +" - " +qendDate 
                descriptions.push(reportdata)
            }
            // if (request?.Criteria) {
            //     let criteria = request.Criteria.toString().split(',');
            //     let key: string = criteria[0];

            //     let n = columns.find(n => {
            //         return options.columnStyles[n]['field'] === key
            //     });
            //     if (n) {
            //         key = options.columnStyles[n]['title'];
            //     }

            //     let d1 = criteria.findIndex(c => c == ">=");
            //     if (d1 >= 0) {
            //         let v1 = criteria[d1 + 1];
            //         let d2 = criteria.findIndex(c => c == "<");
                    
            //         if (d2 >= 0) {
            //             let v2 = criteria[d2 + 1];
                        
            //             descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy"+' (00:00)')}  -  ${Q.formatDate(v2, "dd/MM/yyyy"+' (00:00)')}`);

            //         } else {
            //             descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy")}`);
            //         }
            //     } else {
            //         let d2 = criteria.findIndex(c => c == "<");
            //         if (d2 >= 0) {
            //             let v2 = criteria[d2 + 1];
            //             descriptions.push(`${key} ถึง  ${Q.formatDate(v2, "dd/MM/yyyy")}`);
            //         }
            //     }
            // } else {
            //     descriptions.push("วันที่ = ไม่ระบุ");
            // }

            // // console.log(request)
            // if (request?.EqualityFilter) {
            //     let quickFilters = this.getQuickFilters();

            //     let filters = Object.keys(request.EqualityFilter);

            //     for (let filterCol of filters) {
            //         let quickFilter = Q.first(quickFilters, x => x.field === filterCol);
            //         let filterValue = request.EqualityFilter[filterCol];
            //         // if else{
            //         if (filterValue.length > 0) {
            //             if (Array.isArray(filterValue)) {
            //                 if (quickFilter.options.lookupKey) {
            //                     // console.log(filterValue);
            //                     (filterValue as any[]).forEach(value => {
            //                         var names: string[] = new Array(filterValue);
            //                         for (var i = 0; i < names.length; i++) {
            //                             filterValue = (names[i]);
            //                             console.log(filterValue);
            //                         }
            //                     })

            //                 }
            //             } else {
            //                 filterValue
            //             }
            //         }
            //         else {
            //             filterValue = "ไม่ระบุ"
            //         }
            //         // }

            //         let n = columns.find(n => {
            //             return options.columnStyles[n]['field'] === filterCol
            //         });
            //         if (n) {
            //             descriptions.push(`${options.columnStyles[n]['title']} = ${filterValue}`)
            //         }
            //     }
            // }
            return [descriptions, gridColumns];
        }
        //date pickup
        // protected getQuickFilters() {
        //     var filters = super.getQuickFilters();

        //     Q.first(filters, x => x.field == fld.DocDate).init = w => {

        //         (w as Serenity.DateEditor).valueAsDate = new Date(Date.now());

        //         let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
        //         endDate.valueAsDate = new Date(Date.now());
        //     };

        //     // var q = Q.parseQueryString();
        //     // if (q["ShopId"]) {
        //     //     var category = Q.tryFirst(filters, x => x.field == "ShopId");
        //     //     category.init = e => {
        //     //         e.element.getWidget(Serenity.LookupEditor).value = q["ShopId"];
        //     //     };
        //     // }


        //     return filters;
        // }



        protected createQuickSearchInput() {
        }



        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        // protected usePager() {
        //     return false;
        // }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }


        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1301Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            let reportTitle = 'รายงานสรุปยอดขายตามร้านค้า (Sales summary by shop)'

            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "DocDate", title: "วันที่", cellWidth: 15 },
                1: { field: "FullName", title: "ร้านค้า[Id]", cellWidth: 52, overflow: 'linebreak' },
                2: { field: "ShopId", title: "ร้านค้า", cellWidth: 52, isHidden: true },
                3: { field: "GrossSales", title: "ยอดขายก่อนลด", cellWidth: 30, halign: 'right', aggregate: "sum" },
                4: { field: "AllItemDiscount", title: "ยอดส่วนลดทั้งหมด", cellWidth: 30, halign: 'right', aggregate: "sum" },
                5: { field: "NetSales", title: "ยอดขายสุทธิ", cellWidth: 30, halign: 'right', aggregate: "sum" },
                6: { field: "NetSalesExVat", title: "ยข. สุทธิหักVAT", cellWidth: 30, halign: 'right', aggregate: "sum" },
                7: { field: "VatOfNetSales", title: "VAT(ยอดขาย)", cellWidth: 30, halign: 'right', aggregate: "sum" },
                8: { field: "AllItemCharge", title: "ต่าชาร์จ", cellWidth: 30, halign: 'right', aggregate: "sum" },
                9: { field: "VatOfCharge", title: "VAT(ค่าชาร์จ)", cellWidth: 30, halign: 'right', aggregate: "sum" },
                10: { field: "ShopName", title: "ร้านค้า", isHidden: true },
            }

            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         // head: ,
            //         headerStyles: {
            //             halign: 'center'
            //         },
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'center'
            //             }
            //         }
            //     }
            // }));

            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,

            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         // head: ,
            //         headerStyles: {
            //             halign: 'center'
            //         },
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'center'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpec1301/edit/3';
                        return false;
                    },
                }
            );
            return buttons;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();

            
            

            

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [

                    new Slick.Aggregators.Sum('GrossSales'),
                    new Slick.Aggregators.Sum('AllItemDiscount'),
                    new Slick.Aggregators.Sum('AllItemCharge'),
                    new Slick.Aggregators.Sum('NetSales'),
                    new Slick.Aggregators.Sum('NetSalesExVat'),
                    new Slick.Aggregators.Sum('VatOfNetSales'),
                    new Slick.Aggregators.Sum('VatOfCharge')
                ]

            });
            return grid;
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        
    }
}